import { useState, useEffect } from "react";
import useSound from "use-sound";
import wrongSound from "../assets/sounds/sfx-defeat2.mp3";

function NumberBoxMobile({
    word,
    i,
    backgroundColor,
    words,
    showAnswer,
    updateShowBoxes,
    showBoxes,
}) {
    const [play] = useSound(wrongSound);
    const [isOpened, setIsOpened] = useState(false);
    useEffect(() => {
        setIsOpened(false);
    }, [word, words]);

    useEffect(() => {
        showAnswer && setIsOpened(true);
    }, [showAnswer]);

    useEffect(() => {
        !showAnswer && setIsOpened(showBoxes?.includes(i));
    }, [showBoxes, showAnswer, i]);

    return isOpened ? (
        <div
            className="numberBox"
            style={{
                height: "45%",
                width: "calc(28% - 1vw)",
                margin: "0.5vw",
                //backgroundColor: 'white',
                color: isOpened ? backgroundColor : "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "4vh",
                //fontWeight: 'bold',
                //fontFamily: isOpened ? 'Roboto' : 'Brush Script MT',
                border: "1px solid grey",
                //borderRadius: 10,
                cursor: "pointer",
                userSelect: "none",
                overflow: "hidden",
                padding: "1vw",
                textAlign: "center",
            }}
            mode="single"
            onClick={() => {
                //Update in db
                setIsOpened(!isOpened);
                updateShowBoxes(i);
            }}
        >
            {word}
        </div>
    ) : (
        <div
            className="numberBox"
            style={{
                height: "45%",
                width: "calc(28% - 1vw)",
                margin: "0.5vw",
                //backgroundColor: 'white',
                color: isOpened ? backgroundColor : "black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: isOpened ? "5vh" : "11vh",
                //fontWeight: 'bold',
                //fontFamily: isOpened ? 'Roboto' : 'Brush Script MT',
                border: "1px solid grey",
                //borderRadius: 10,
                cursor: "pointer",
                userSelect: "none",
            }}
            onClick={() => {
                setIsOpened(!isOpened);
                updateShowBoxes(i);
            }}
        >
            <div style={{}}>{i + 1}</div>
        </div>
    );
}

export default NumberBoxMobile;
